import React from "react";

type Props = {
    kind: string;
};

const WorkbenchNewEntityTypeTag: React.FC<Props> = ({ kind }) => {
    const normalizedKind = kind.trim() || "N/A";
    const kindClassName = normalizedKind
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-");

    return (
        <span
            className={`workbench-new-entity-type workbench-new-entity-type-${kindClassName}`}
        >
            {normalizedKind}
        </span>
    );
};

export default WorkbenchNewEntityTypeTag;
